import React from "react";
import { WarningCircle, ArrowClockwise, House } from "@phosphor-icons/react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error, info) { console.error("PalletNext page error", error, info); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="min-h-[70vh] p-4 sm:p-8 flex items-center justify-center">
      <div className="w-full max-w-lg bg-white border border-slate-200 shadow-sm p-6 sm:p-8 text-center">
        <WarningCircle size={42} weight="duotone" className="mx-auto text-amber-500"/>
        <h1 className="text-xl font-extrabold mt-3">Bu sayfa yüklenirken bir sorun oluştu</h1>
        <p className="text-sm text-slate-500 mt-2 leading-6">Verileriniz silinmedi. Sayfayı yeniden deneyebilir veya Dashboard'a dönebilirsiniz.</p>
        <div className="mt-5 flex flex-col sm:flex-row justify-center gap-2">
          <button onClick={() => { this.setState({ failed: false }); window.location.reload(); }} className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white font-semibold text-sm"><ArrowClockwise size={16}/>Tekrar Dene</button>
          <button onClick={() => { window.location.href = "/app"; }} className="inline-flex items-center justify-center gap-2 px-4 py-2 border border-slate-300 bg-white font-semibold text-sm"><House size={16}/>Dashboard</button>
        </div>
      </div>
    </div>;
  }
}
